<template>
  <div id="password-manage">
    <a-modal
      v-model="show"
      title="分享"
      @ok="saveShareUrl"
      @cancel="closeShare"
      centered
      okText="更新"
      cancelText="关闭"
    >
      <div class="model-form">
        <div class="model-form-item">
          <div class="model-form-item-label">分享链接:</div>
          <div class="model-form-item-input">
            <a-input
              placeholder=""
              v-model="shareInfo.url"
              style="width: 66%"
              readOnly
            />
            <div class="model-form-item-input-tag">
              <span
                　　v-clipboard:copy="shareText"
                　　v-clipboard:success="copyLink"
                　　style="cursor: copy;"
              >
                <a-tag color="blue">复制链接</a-tag>
              </span>
            </div>
          </div>
        </div>
        <div class="model-form-item">
          <div class="model-form-item-label">提取密码:</div>
          <div class="model-form-item-input">
            <a-input-password
              placeholder="打开分享需要的密码"
              v-model="shareInfo.pwd"
              style="width: 66%"
            />
          </div>
        </div>
        <div class="model-form-item">
          <div class="model-form-item-label">过期时间:</div>
          <div class="model-form-item-input">
            <div>
              <a-date-picker
                show-time
                placeholder="过期后链接失效"
                @change="setTime"
                :locale="locale"
                v-model="shareInfo.effectTime"
              />
            </div>
          </div>
        </div>
        <div class="model-form-item">
          <div class="model-form-item-label">共享账号:</div>
          <div class="model-form-item-input">
            <div class="flex-start-between" style="width: 80%">
              <a-switch v-model="shareInfo.sharePwd" />
              <div>
                <a-popover title="">
                  <template slot="content">
                    <p>其它用户打开分享链接后</p>
                    <p>可以查看你的书签对应的</p>
                    <p>账号和密码。</p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
              </div>
            </div>
          </div>
        </div>
        <div class="model-form-item">
          <div class="model-form-item-label">阅后即焚:</div>
          <div class="model-form-item-input">
            <div class="flex-start-between" style="width: 80%">
              <a-switch v-model="shareInfo.readDelete" />
              <div>
                <a-popover title="">
                  <template slot="content">
                    <p>其它用户查看一次分享链接后</p>
                    <p>此分享链接会立即删除</p>
                  </template>
                  <a-icon type="question-circle" />
                </a-popover>
              </div>
            </div>
          </div>
        </div>
        <div class="model-form-item">
          <div class="model-form-item-label"></div>
          <div class="model-form-item-input">
            <div style="margin-left: 100px">
               <a-popconfirm
    title="确认要关闭分享?"
    ok-text="确认"
    cancel-text="取消"
    @confirm="closeShareAndDel"
  >
              <a-button type="danger" >关闭分享</a-button>
               </a-popconfirm>
            </div>
            
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import { defineComponent, ref } from "vue";
export default {
  props: ["showShare", "favId"],
  data() {
    return {
      shareInfo: {},
      locale,
      moment,
    };
  },
  methods: {
    saveShareUrl() {
      this.$req.post("/api/share/update", this.shareInfo, (res) => {
        this.$message.success("更新成功！");
      });
    },
    closeShare() {
      this.$emit("closeShare");
    },
    copyLink() {
      this.$message.success("复制成功！");
    },
    setTime(val) {
      this.shareInfo.effectTime = this.$util
        .formatDate(new Date(val.valueOf()), "yyyy-MM-dd hh:mm:ss")
        .toString();
    },
    closeShareAndDel(){
       this.$req.get("/api/share/close/" + this.shareInfo.id, {}, (res) => {
        this.$message.success("关闭成功！");
        this.$emit("closeShare");
      });
    }
  },
  computed: {
    show: {
      get() {
        return this.showShare;
      },
      set(val) {
        this.$emit("closeShare");
      },
    },
    shareText() {
      let text = "";
      if (this.shareInfo.creatorName) {
        text += this.shareInfo.creatorName;
      }
      text += "分享了一个链接给你:\n";
      text += "链接地址：" + this.shareInfo.url;
      if (this.shareInfo.pwd) {
        text += "\n提取密码：" + this.shareInfo.pwd;
      }
      return text;
    },
  },
  mounted() {
    this.$req.get("/api/share/select/favorites/" + this.favId, {}, (res) => {
      this.shareInfo = res.data;
      let targetUrl = `${location.origin}/share/${res.data.id}`;
      this.shareInfo.url = targetUrl;
      console.log(moment(res.data.effectTime, "yyyy-MM-dd hh:mm:ss"));
    });
  },
};
</script>